import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";
import { forwardRef, useImperativeHandle, useState } from "react";
import config from "../../../config";
import ConfirmButton from "../../../components/button/ConfirmButton";
import CancelButton from "../../../components/button/CancelButton";
import { fetchWithToken } from "../../../authentication/AuthProvider";

const DialogAddPartner = forwardRef(({ onSuccess = () => {} }, ref) => {
  const [open, setOpen] = useState(false);
  const [invitationKey, setInvitationKey] = useState("");
  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
    close: () => setOpen(false),
  }));
  const handleAdd = () => {
    const url = config.partnership.invite_partner;
    const body = { invitation_key: invitationKey };
    fetchWithToken(url, {
      ...config.method.POST,
      body: JSON.stringify(body),
      headers: config.header.json,
    }).finally(() => {
      setOpen(false);
      onSuccess();
    });
  };
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      //   PaperProps={{
      //     sx: {
      //       width: "auto",
      //       maxWidth: "none",
      //       padding: 2,
      //     },
      //   }}
    >
      <DialogTitle sx={{ alignItems: "center" }}>
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontSize: "24px",
            color: "black",
            textWrap: "nowrap",
            textAlign: "left",
          }}>
          Input Invitation Key
        </Typography>
      </DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <Typography
            sx={{
              fontFamily: "Poppins",
              fontSize: "16px",
              color: "black",
              textWrap: "nowrap",
              textAlign: "left",
              padding: 0.5,
            }}>
            Partner's invitation key
          </Typography>
          <TextField
            placeholder="Invitation Key"
            value={invitationKey}
            onChange={(e) => setInvitationKey(e.target.value)}
            sx={{
              "& .MuiInputBase-root": {
                fontFamily: "Poppins",
              },
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: 3,
                  borderColor: "#16a34a",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#16a34a",
                },
              },
            }}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={() => setOpen(false)} label={"Cancel"} />
        <ConfirmButton onClick={handleAdd} label={"Add"} />
      </DialogActions>
    </Dialog>
  );
});
export default DialogAddPartner;
